// @flow

import RefreshPassword from "./RefreshPassword";

export default RefreshPassword;
